import { ROLES } from "./roles";

export const DIR_EDITORIAL_SELECTED_ROL_OPTIONS = [
  { _id: ROLES.editorEditorial, nombre: "Editor editorial" },
  { _id: ROLES.autorEditorial, nombre: "Armador editorial" },
  { _id: ROLES.autorIndependiente, nombre: "Autor independiente" },
];

export const GENERAL_DISTRIBUIDOR_ROL_OPTIONS = [
  { _id: ROLES.distribuidor, nombre: "Distribuidor" },
  { _id: ROLES.asesor, nombre: "Asesor" },
];

export const DISTRIBUIDOR_ROL_OPTIONS = [
  { _id: ROLES.asesor, nombre: "Asesor" },
];

export const CORPORATIVO_ROL_OPTIONS = [
  { _id: ROLES.corporativo, nombre: "Director corporativo" },
];

export const PLANTEL_ROL_OPTIONS = [
  { _id: ROLES.plantel, nombre: "Director de plantel" },
  { _id: ROLES.operativo, nombre: "Administrador operativo" },
  { _id: ROLES.coordinador, nombre: "Coordinador académico" },
  { _id: ROLES.autor, nombre: "Armador escolar" },
  { _id: ROLES.editor, nombre: "Editor escolar" },
  { _id: ROLES.profesor, nombre: "Profesor" },
  { _id: ROLES.alumno, nombre: "Alumno" },
  { _id: ROLES.padre, nombre: "Tutor" },
];

export const DIR_PLANTEL_ROL_OPTIONS = [
  { _id: ROLES.operativo, nombre: "Administrador operativo" },
  { _id: ROLES.coordinador, nombre: "Coordinador académico" },
  { _id: ROLES.autor, nombre: "Armador escolar" },
  { _id: ROLES.editor, nombre: "Editor escolar" },
  { _id: ROLES.profesor, nombre: "Profesor" },
  { _id: ROLES.alumno, nombre: "Alumno" },
  { _id: ROLES.padre, nombre: "Tutor" },
];

export const ADMIN_OPERATIVO_ROL_OPTIONS = [
  { _id: ROLES.coordinador, nombre: "Coordinador académico" },
  { _id: ROLES.autor, nombre: "Armador escolar" },
  { _id: ROLES.editor, nombre: "Editor escolar" },
  { _id: ROLES.profesor, nombre: "Profesor" },
  { _id: ROLES.alumno, nombre: "Alumno" },
  { _id: ROLES.padre, nombre: "Tutor" },
];

export const PROFESOR_ROL_OPTIONS = [
  { _id: ROLES.alumno, nombre: "Alumno" },
  { _id: ROLES.padre, nombre: "Tutor" },
];

export const TODOS_OPTION = [{ _id: "Todos", nombre: "Todos" }];

// Al dar de baja a un usuario se marca esEliminado y se le agrega el sufijo
// "_baja" a su correo, pero los destinatarios que ya lo referenciaban siguen
// llegando en la lista. Además, si el usuario ya no existe, la respuesta trae
// el destinatario sin la propiedad `usuario`.
const SUFIJO_BAJA = "_baja";

export const esDestinatarioVigente = (destinatario) => {
  const usuario = destinatario?.usuario;
  if (!usuario?._id) return false;
  if (usuario.esEliminado) return false;
  return !usuario.correoElectronico?.includes(SUFIJO_BAJA);
};

export const filtrarDestinatariosVigentes = (destinatarios) =>
  (destinatarios ?? []).filter(esDestinatarioVigente);
